import React, {useState} from 'react';
import {MapContainer, Marker, Popup, TileLayer} from 'react-leaflet';
import {mapCustomIcon, mapTiles} from '../../../mock/mapTiles';
import L, {LatLngTuple} from 'leaflet';
import {KTIcon} from '../../../../_metronic/helpers';
import {useQuery} from 'react-query';
import {getSosPlaces, updateSosPlace} from '../../../services/sosPlaceSvc';
import MarkerClusterGroup from 'react-leaflet-cluster';
import {separateFormatter} from '../../../utils/separateFormatter';
import {lang} from '../../../types/lang';
import {Button} from "react-bootstrap";
import MapEvents from "./components/MapEvents";
import SosModal from "./components/SosModal";
import {useDeleteModal} from "../../../context/DeleteModalContext";
import {MODERATOR_PLACE} from "../../../mock/URLs";

export const SosPlacesPage = () => {
  const [tile, setTile] = useState<string>(mapTiles[0].url);
  const [map, setMap] = useState<L.Map | null>(null);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [clickedLocation, setClickedLocation] = useState<LatLngTuple | null>(null);
  const [selectedPlace, setSelectedPlace] = useState<any>(null);
  const {data: sosPlaces, refetch: refetchSosPlaces} = useQuery('getSosPlaces', () => getSosPlaces());
  const [activeTab, setActiveTab] = useState<lang>('uz');

  const handleMarkerClick = (latlng: LatLngTuple) => {
    if (map) {
      map.setView(latlng, 15);
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedPlace(null);
  };

  const handleTabChange = (lang: lang) => {
    setActiveTab(lang);
  };

  const {openDeleteModal} = useDeleteModal()

  const handleDeleteClick = (id: number) => {
    openDeleteModal(MODERATOR_PLACE, id, refetchSosPlaces);
  };

  const handleMarkerDragEnd = async (id: number, event: L.DragEndEvent) => {
    const marker = event.target;
    const position = marker.getLatLng();
    try {
      await updateSosPlace(id, {latitude: position.lat, longitude: position.lng});
      refetchSosPlaces();
    } catch (e) {
      console.error('Failed to update SOS place location', e);
    }
  };

  const handleEditClick = (place: any) => {
    setSelectedPlace(place);
    setClickedLocation([place.latitude, place.longitude]);
    setShowModal(true);
  };

  const [searchQuery, setSearchQuery] = useState<string>('');
  const filteredPlaces = sosPlaces?.data?.filter((place: any) =>
      place.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleSearch = () => {
    if (filteredPlaces.length > 0 && map) {
      const firstPlace = filteredPlaces[0];
      map.setView([firstPlace.latitude, firstPlace.longitude], 15);
    }
  };

  return (
      <div>
        <div className={"d-flex justify-content-between align-items-center mb-10"}>
          <div>
            <h1 className={"page-heading d-flex text-gray-900 fw-bold fs-3 my-0 flex-column justify-content-center"}>SOS
              markazlari</h1>
            <p className={"text-muted m-0"}>Jami markazlar
              soni: {separateFormatter(sosPlaces?.data?.length, ' ', 'ta') || 0}</p>
          </div>
        </div>
        <div className={"position-relative"}>
          <div className={"w-auto w-md-100 w-lg-500px position-absolute d-flex align-items-start gap-3"}
               style={{top: 10, left: 10, zIndex: 10}}>
            <div className={"position-relative w-auto w-md-100 w-lg-500px"}>
              <input
                  type="text"
                  className={"form-control w-100 w-md-200px w-lg-500px"}
                  placeholder="Markaz nomi bo‘yicha qidirish..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
              />
              {
                searchQuery && <ul className={"list-unstyled bg-white p-2 rounded-4 shadow-sm position-absolute w-100 mh-300px overflow-auto mt-2"}>
                    {filteredPlaces?.map((place: any) => (
                        <li key={place.id} onClick={
                          () => map?.setView([place.latitude, place.longitude], 15)
                        } className={"d-flex text-hover-primary cursor-pointer mt-2 justify-content-between align-items-center border p-3 rounded-4"}>
                          {place.name}
                        </li>
                    ))}
                  </ul>
              }
            </div>
            <Button variant={"primary"} onClick={handleSearch}>Qidirish</Button>
          </div>

          <div className={"position-absolute d-flex align-items-center gap-3"}
               style={{top: 10, right: 10, zIndex: 10}}>
            <select className={"form-select w-200px"} name="" id="" onChange={(e) => setTile(e.target.value)}>
              {mapTiles.map((tile, index) => (
                  <option key={index} value={tile.url}>{tile.name}</option>
              ))}
            </select>
          </div>
          <div className={"w-100 overflow-hidden d-flex justify-content-center rounded-4"}>
            <div>
              <MapContainer
                  center={[41.5, 64.0] as LatLngTuple}
                  className={"center-of-map-selectable shadow-sm position-relative"}
                  style={{height: '70vh', width: '100vw'}}
                  zoom={6}
                  scrollWheelZoom={true}
              >
                <TileLayer url={tile}/>
                <MapEvents setMap={setMap} setClickedLocation={setClickedLocation}/>
                <MarkerClusterGroup>
                  {filteredPlaces?.map((place: any, index: number) => (
                      <Marker
                          key={index}
                          position={[place.latitude, place.longitude]}
                          icon={mapCustomIcon}
                          draggable={true}
                          eventHandlers={{
                            click: () => handleMarkerClick([place.latitude, place.longitude]),
                            dragend: (event) => handleMarkerDragEnd(place.id, event)
                          }}
                      >
                        <Popup className={"m-0"} closeButton={false}>
                          <h3>{place?.name}</h3>
                          <p className={"text-muted"}>{place?.latitude}, <br/> {place?.longitude}</p>
                          <div className={"d-flex justify-content-center gap-1"}>
                            <Button variant={"primary"} className={"btn-icon btn-sm"}
                                    onClick={() => handleEditClick(place)}>
                              <KTIcon iconName={"pencil"} className={"fs-2"}/>
                            </Button>
                            <a rel={"noreferrer"} target={"_blank"} className={"btn btn-warning btn-sm text-black"}
                               href={`https://yandex.com/maps/?pt=${place.longitude},${place.latitude}&z=15&rtext=${place.latitude},${place.longitude}&rtt=auto`}>
                              <KTIcon iconName={"geolocation"} className={"fs-2 text-black"}/> Yandexda ochish
                            </a>
                            <Button onClick={() => handleDeleteClick(place?.id)} variant={"danger"}
                                    className={"btn-icon btn-sm"}>
                              <KTIcon iconName={"trash-square"} className={"fs-2"}/>
                            </Button>
                          </div>
                        </Popup>
                      </Marker>
                  ))}
                </MarkerClusterGroup>
                {clickedLocation && (
                    <Marker position={clickedLocation} icon={mapCustomIcon}>
                      <Popup className={"m-0"} closeButton={false}>
                        <Button variant="primary" onClick={() => setShowModal(true)}>Qo'shish</Button>
                      </Popup>
                    </Marker>
                )}
              </MapContainer>
            </div>
          </div>
        </div>
        <SosModal
            showModal={showModal}
            handleModalClose={handleModalClose}
            activeTab={activeTab}
            setActiveTab={handleTabChange}
            clickedLocation={clickedLocation as LatLngTuple}
            refetchSosPlaces={refetchSosPlaces}
            setClickedLocation={setClickedLocation}
            selectedPlace={selectedPlace}
        />
      </div>
  );
};